// extracted by mini-css-extract-plugin
export default {"formBlock":"FormBlock_formBlock__Qx5C9","title":"FormBlock_title__IWE0G","red":"FormBlock_red__a01u6","description":"FormBlock_description__0Ndus","bold":"FormBlock_bold__RbVo4"};